import { render, staticRenderFns } from "./ProductInterfaceList.vue?vue&type=template&id=44d66c10&class=ProductInterfaceList"
import script from "./ProductInterfaceList.vue?vue&type=script&lang=js"
export * from "./ProductInterfaceList.vue?vue&type=script&lang=js"
import style0 from "./ProductInterfaceList.vue?vue&type=style&index=0&id=44d66c10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports